// extracted by mini-css-extract-plugin
export default {"videoPreview":"xT5Zh","posterImage":"PRnDn","playIcon":"dXVQ3","sizeS":"C07bJ","sizeM":"l5gpF","sizeL":"P02JH","cnImage":"YzTCz","container":"q3vEq"};